import React, { useMemo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../redux/rootState';
import { setLoader } from '../../../redux/loaderSlice';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../../Common/DataTable';
import { getCustomersStart } from '../redux/sliceSites';
import { stripCustPrefix } from '../../../utils/CommonFunctions';
import { defaultPageSize } from '../../../utils/Constant';

interface CustomersData {
  sn: number;
  customerId: string;
  customerName: string;
  id: string;
}

// Not in use
export default function ComponentSiteCustomersTable() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');

  const dispatch = useDispatch();
  const { siteId } = useParams();
  const { customersList, isLoading, totalEntries } = useSelector((state: RootState) => state.siteReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
      siteId,
    };
    dispatch(getCustomersStart(params));
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const columns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'customerId', label: 'Customer ID' },
      { key: 'customerName', label: 'Customer' },
    ],
    [],
  );

  const data: CustomersData[] = useMemo(() => customersList.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      customerId: stripCustPrefix(item?.CustomerId),
      customerName: item?.CustomerName,
      id: item?.CustomerId,
    };
    return transformedDataItem;
  }), [customersList]);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  return (
    <>
      <ComponentPageHeader subHeading="Customers" />
      <DataTable<CustomersData>
        data={data}
        columns={columns}
        totalRecords={totalEntries}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
        sortCol={sortCol}
        setSortCol={(e) => { setSortCol(e); setPage(1); }}
        sortDir={sortDir}
        setSortDir={(e) => { setSortDir(e); setPage(1); }}
        handleData={handleData}
        handleDataFromComponent
      />
    </>
  );
}
